export const styles = {
  historyContainer: {
    backgroundColor: "#FFFFFF",
    height: "100%",
    margin: "0px",
    overflow: "auto",
    borderBottomLeftRadius: "15px",
    borderBottomRightRadius: "15px",
  },

  wrapper: {
    padding: "20px",
    width: "100%",
  },

  filtersRow: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    width: "100%",
    marginBottom: "20px",
  },

  sortIcon: {
    width: "24px",
    height: "24px",
    cursor: "pointer",
    flexShrink: 0,
  },
  emptyBox: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: "12px",
  },

  emptyTitle: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "28px",
    color: "#131316",
    width: "169px",
  },

  emptySubtitle: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "25px",
    color: "#7D8690",
    width: "529px",
  },
};
